export const IndexedDBConstants = {

  VERSION: 9,

  FT_DOCUMENTS_DB_NAME_PREFIX: 'ft-documents-',
  FT_PROPERTIES_TABLE_NAME: 'ftProperties',
  FT_PROPERTIES_TABLE_INDEX_KEY: 'key',
  DB_NAME: 'formbird',
  DB_INDEXES: 'indexedDBIndexes',

  // document store constants
  DOCUMENT_TABLE_NAME: 'documents',
  DOCUMENT_INDEX_PENDING_OPERATION: 'systemHeader.offlineDetails.status',
  DOCUMENT_INDEX_VERSION_ID: 'systemHeader.versionId',
  DOCUMENT_INDEX_DOCUMENT_ID: 'documentId',
  DOCUMENT_INDEX_SYSTEM_TYPE: 'systemHeader.systemType',
  DOCUMENT_INDEX_SUMMARY_NAME: 'systemHeader.summaryName',

  // under offlineFiles store
  OFFLINE_FILE_TABLE_NAME : 'offlineFiles',
  OFFLINE_FILE_INDEX_STATUS : 'status',
  OFFLINE_FILE_INDEX_FILENO : 'fileNo',

  // universal offline statuses
  OFFLINE_STATUS_UPLOADED : 1, // cached or already uploaded
  OFFLINE_STATUS_PENDING : 0, // waiting for upload
  OFFLINE_STATUS_UPLOADING : 2, // uploading
  OFFLINE_STATUS_FAILED: -1
} as any;

// the systemHeader.versionId needs to be first because it is the primary key
IndexedDBConstants.DOCUMENT_INDEXES = [IndexedDBConstants.DOCUMENT_INDEX_VERSION_ID,
  IndexedDBConstants.DOCUMENT_INDEX_DOCUMENT_ID,
  IndexedDBConstants.DOCUMENT_INDEX_SYSTEM_TYPE,
  IndexedDBConstants.DOCUMENT_INDEX_PENDING_OPERATION,
  IndexedDBConstants.DOCUMENT_INDEX_SUMMARY_NAME];
